var map = {
	"./wscn-icon-stack.vue": 255,
	"./wscn-icon-svg.vue": 256
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 283;


//////////////////
// WEBPACK FOOTER
// ./src/components/Icon-svg nonrecursive \.vue$
// module id = 283
// module chunks = 30